import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
const fulInfo = JSON.parse(localStorage.getItem("myCat"));
export const exportToExcel = (rawData, fileName = 'talabalar.xlsx') => {
    const mappedData = rawData.map(item => {
        const pagerow = {
            "F.I.SH": item.student?.fullName || "",
            "Talaba ID": item.student?.profile_id_number || "",
            "Kurs": item.student?.levelInfo?.name || "",
            "Guruh": item.student?.groupInfo?.name || "",
            "O‘quv yili": item.education_year_info?.name || "",
            "Fakultet": item.student?.departmentInfo?.name || "",
            "Yo‘nalish": item.student?.specialtyInfo?.name || "",
            "Hozirgi holati": item.student?.paymentFormInfo?.name || "",
            "Telefon": item.phone || "",
            // "Ijtimoiy faollik ball": item.departmentRating ?? "yo‘q",
            // "Akademik o‘zlashtirish ko‘rsatkichi": item.academicRating ?? "yo‘q",
            // "Umumiy ball": item.academicAndDepartmentRating ?? "yo‘q",
        };
        if (fulInfo.currentRole === "ROLE_ADMIN") {
            pagerow["GPA"] = item.student?.avg_gpa ?? "yo‘q"
            pagerow["Ijtimoiy faollik ball"] = item.departmentRating ?? "yo‘q"
            pagerow["Akademik o‘zlashtirish ko‘rsatkichi"] = item.academicRating ?? "yo‘q"
            pagerow["Umumiy ball"] = item.academicAndDepartmentRating ?? "yo‘q"
        }
        return pagerow;
    });


    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    // 👇 Ustun kengliklarini belgilang
    worksheet['!cols'] = [
        { wch: 30 }, // F.I.SH
        { wch: 10 }, // Kurs
        { wch: 18 }, // Guruh
        { wch: 12 }, // O‘quv yili
        { wch: 35 }, // Fakultet
        { wch: 30 }, // Yo‘nalish
        { wch: 20 }, // Hozirgi holati
        { wch: 18 }, // Telefon
        { wch: 20 }, // Ijtimoiy faollik ball
        { wch: 6 },  // GPA
        { wch: 22 }, // Akademik
        { wch: 15 }  // Umumiy ball
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Talabalar");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, fileName);
};
